export const getCurrentReservationPath = (pathname: string) => {
  if (pathname.startsWith("/arrivals")) return "/arrivals";
  if (pathname.startsWith("/departures")) return "/departures";
  if (pathname.startsWith("/in-house")) return "/in-house";

  return "/reservations";
};
